// Table motif_id → libellé FR pour le dashboard Modération IA (contrat CD5, ticket B2_01, D9).
//
// ⛔ POURQUOI CETTE COPIE EXISTE. L'API ne renvoie que l'identifiant numérique du motif
// (`by_motif[].motif_id` de CD1) : le backend ne stocke pas de libellé, et
// `DOCS/02_regles_metier.md` l'acte — « Source des labels : i18n du frontend. Le backend ne
// stocke que l'identifiant numérique. » Sans cette table, l'écran afficherait « motif 5 : 106 ».
//
// ⛔ NE PAS utiliser `llm_result.result_moderation.motif_label`, le libellé que l'IA écrit
// elle-même. Mesuré sur la base locale : le seul motif 0 y apparaît sous SIX libellés distincts
// (`Non précisé`, `Non specificato`, `non precisato`, `non precisé`, `non précisé`,
// `non specificato` — FR/IT, variantes de casse et d'accent). S'y fier éclaterait une ligne du
// tableau en six. C'est d'ailleurs pour cela que l'API ne le lit nulle part (D9, option A).
//
// SOURCE DE RECOPIE : `graphproject/packages/back-office/public/lang/fr.json`, clés `motif_0`
// … `motif_24` + `motif_99` — la taxonomie PRODUIT, celle que voit le modérateur dans le
// back-office. C'est elle qui fait foi à l'affichage.
//
// ⚠ DIVERGENCE CONNUE PROMPT ↔ PRODUIT sur le 24. Les prompts des agents Mistral décrivent le
// 24 comme « Harcèlement moral ou cyberharcèlement », le produit comme « Vulgarité » (audit P1
// §4.2.6, « dérive de taxonomie »). On affiche la version PRODUIT : le motif finit sur la fiche
// du commentaire et dans le malus de réputation, où c'est le sens produit qui s'applique.
//
// ⚠ LE 25 N'EXISTE PAS CÔTÉ PRODUIT. Les prompts le produisent (« Désinformation avérée ») sans
// qu'il ait ni clé i18n, ni poids de malus, ni existence en back-office — 11 occurrences en base
// locale, 4 remontées par CD1 sur la fenêtre large. Il lui faut donc un libellé de repli
// EXPLICITE, qui dise que le motif sort de la taxonomie : le taire ferait passer une anomalie de
// prompt pour un motif normal (trou T8 de COHERENCE.md).
//
// ⚠ Table de LECTURE, jamais de saisie : on n'écrit pas de motif depuis le super-admin.
// À resynchroniser si la taxonomie produit bouge (elle n'a pas bougé depuis l'audit de 07/2026).

// 0 → 24 + 99 : recopie fidèle de l'i18n back-office (26 clés vérifiées à l'extraction).
// 25 : hors taxonomie produit, libellé de repli explicite (cf. en-tête).
const MOTIF_LABELS = {
  0: 'Non précisé',
  1: 'Diffamatoire',
  2: 'Aggression',
  3: 'Insulte',
  4: 'Racisme',
  5: 'Illégal',
  6: 'Pseudo vulgaire',
  7: 'Vie privée',
  8: 'SPAM',
  9: 'Pub',
  10: 'Pédophilie',
  11: 'Porno',
  12: 'Blagues',
  13: 'Suicide',
  14: 'Illisible',
  15: 'Prostitution',
  16: 'Respect Victime',
  17: 'Prosélytisme religieux',
  18: 'Injure sur religion',
  19: "Droits d'auteurs",
  20: 'Doublon',
  21: 'Lien vers un site web prohibé',
  22: 'Incitation violence/crime/vol',
  23: 'Homophobie',
  24: 'Vulgarité',
  25: 'Désinformation avérée (hors taxonomie produit)',
  99: 'Autre motif'
};

// Motifs que l'IA produit alors qu'ils n'existent pas côté produit. L'écran les signale au lieu
// de les afficher comme n'importe quel autre motif (trou T8).
const OUT_OF_TAXONOMY = [25];

// Libellé affichable d'un motif. Repli défensif obligatoire (COHERENCE §Décisions actées) :
// ce que l'endpoint ne normalise pas remonte tel quel, donc on ne fait JAMAIS confiance à l'enum.
//   - identifiant connu       → son libellé produit
//   - identifiant inconnu     → « Motif <n> (hors taxonomie) », le numéro reste lisible
//   - null / undefined / NaN  → « (inconnu) », jamais une chaîne vide qui laisserait une case nue
function motifLabel(motifId) {
  if (motifId === null || motifId === undefined || motifId === '') return '(inconnu)';
  const n = Number(motifId);
  if (!Number.isFinite(n)) return '(inconnu)';
  if (Object.prototype.hasOwnProperty.call(MOTIF_LABELS, n)) return MOTIF_LABELS[n];
  return `Motif ${n} (hors taxonomie)`;
}

// `true` si le motif est produit par l'IA sans exister côté produit — l'écran le marque.
// Un identifiant absent de la table l'est aussi par définition.
function isOutOfTaxonomy(motifId) {
  const n = Number(motifId);
  if (!Number.isFinite(n)) return false;
  return OUT_OF_TAXONOMY.indexOf(n) !== -1
    || !Object.prototype.hasOwnProperty.call(MOTIF_LABELS, n);
}

export { MOTIF_LABELS, motifLabel, isOutOfTaxonomy };
export default { MOTIF_LABELS, motifLabel, isOutOfTaxonomy };
